export default function getResource(label) {
    const resources = {
        oosMessagePrefix: 'Some items are out of stock. ',
        oosMessageLink: 'Choose a different store',
        oosMessageSuffix: ' for your order, or change method for each item.'
    };

    return resources[label];
}
